import { render, staticRenderFns } from "./createTpl.vue?vue&type=template&id=7a2180ec&scoped=true"
import script from "./createTpl.vue?vue&type=script&lang=js"
export * from "./createTpl.vue?vue&type=script&lang=js"
import style0 from "./createTpl.vue?vue&type=style&index=0&id=7a2180ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2180ec",
  null
  
)

export default component.exports